import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ycglj02w: FaireBrandEntity = {
  token: "b_ycglj02w",
  type: "brand",
  name: "Even Keel",
  avatarUrl:
    "https://cdn.faire.com/fastly/29ea35092e84693f4d361651e9773d60d9698a1cdfeed36f5aa3e568f98a2e2a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/27430aee031d1b026e50ba21191e2450309d9257c2c4894e1cbe71569719c353.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/29ea35092e84693f4d361651e9773d60d9698a1cdfeed36f5aa3e568f98a2e2a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/27430aee031d1b026e50ba21191e2450309d9257c2c4894e1cbe71569719c353.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 45,
  isTopShop: true,
  isInsider: true,
  description:
    'Our studio handcrafts our collection and stands AGAINST animal testing, animal products, artificial coloring, fragrance oils, filler ingredients, mineral oils / petroleum, parabens, phthalates, sodium lauryl/laureth sulfate, and synthetic preservatives.\n\nAs an Apothecary and Soap House in Brooklyn, Even Keel infuses Eastern Roots with Western Herbs to handcraft a conscientious line with a principal focus on the earth’s natural clays, oils and botanicals.\n\nOur studio formulates and handcrafts each product with "Form and Function" in mind — creating aesthetically beautiful yet natural products.',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:07.492Z",
    importedBy: "entity-db-cli",
  },
};
